var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9718 14.3997C19.2033 14.2017 19.5566 14.1804 19.8087 14.3802C20.0922 14.6042 20.1393 15.0163 19.924 15.3021L19.923 15.304L16.8683 19.1829C17.227 19.8021 17.2058 20.6047 16.7384 21.2073L16.7375 21.2083C16.1243 21.9872 14.9897 22.1329 14.2033 21.5159C13.4239 20.906 13.2777 19.7711 13.8947 18.9847L13.9894 18.8734C14.466 18.359 15.1794 18.1753 15.8224 18.3724L18.881 14.4944L18.9718 14.3997Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.178571
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9435 10.3186C22.7881 10.3187 23.4689 10.996 23.4689 11.8411C23.4688 12.6892 22.7881 13.3663 21.9435 13.3665C21.0985 13.3665 20.4212 12.689 20.4211 11.8411C20.4211 10.9961 21.0986 10.3186 21.9435 10.3186Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.178571
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4885 7.33575C16.3334 7.33575 17.0148 8.01626 17.0149 8.86115C17.0149 9.70633 16.3332 10.3836 15.4885 10.3836C14.6439 10.3836 13.9631 9.7063 13.9631 8.86115C13.9632 8.01629 14.6436 7.3358 15.4885 7.33575Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.178571
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1116 15.4142C24.9595 15.4143 25.637 16.0917 25.637 16.9366C25.6369 17.7846 24.9596 18.4619 24.1116 18.462C23.2666 18.462 22.5892 17.7846 22.5891 16.9366C22.5891 16.0917 23.2667 15.4142 24.1116 15.4142Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.178571
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94696 10.3544C9.79498 10.3545 10.4723 11.0317 10.4724 11.8798C10.4724 12.7247 9.79488 13.4021 8.94696 13.4022C8.10204 13.4022 7.4245 12.7247 7.4245 11.8798C7.42454 11.0318 8.10194 10.3544 8.94696 10.3544Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.178571
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90085 15.3793C7.74551 15.3793 8.42722 16.0566 8.42722 16.9017C8.42711 17.7499 7.74557 18.4271 6.90085 18.4271C6.05617 18.4271 5.37557 17.7499 5.37546 16.9017C5.37546 16.0566 6.05623 15.3793 6.90085 15.3793Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.178571
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4981 5.59015C22.128 5.59015 27.5214 10.983 27.5215 17.6097C27.5215 19.9171 26.8628 22.1435 25.6299 24.0901L25.629 24.0921C25.4519 24.3542 25.1568 24.5179 24.8331 24.5179H6.16412C5.83999 24.5179 5.54804 24.3539 5.37115 24.0921L5.37018 24.0901C4.13711 22.1593 3.47858 19.9169 3.47858 17.6097C3.47873 10.9831 8.87154 5.5903 15.4981 5.59015ZM15.4981 6.88312C9.63812 6.88326 4.87411 11.5412 4.87408 17.262C4.87408 19.2644 5.15729 21.2048 6.2442 22.8646L6.29498 22.931C6.42274 23.0764 6.61188 23.1644 6.81451 23.1644L24.086 23.1478C24.3203 23.1477 24.5308 23.0334 24.6592 22.845C25.7444 21.1701 26.126 19.2601 26.126 17.262C26.126 11.5411 21.3583 6.88312 15.4981 6.88312Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.178571
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngboard);
export default __webpack_public_path__ + "static/media/engboard.8e93b5dde3844e3a2f2f1d8614eec7c3.svg";
export { ForwardRef as ReactComponent };